<!-- KYMW7007 表紙・特集商品選定依頼確認（担当バイヤー用） -->
<div class="contents-area">
  <div>
    <h1>商品選定依頼内容</h1>
    <div class="element-column">
      <div class="block-row">
        <div class="column-list">
          <label class="list-input-title">受注コード</label>
          <div class="list-input-content">
            <input type="text" class="deliv-catalog text-label-required" #txti_OrderCode [(ngModel)]="model.orderCode" [maxlength]="7" plessInputTextSub [restrict]="'[0-9]'"
              (ngModelChange)="orderCodeChangedHandler();">
          </div>
          <label class="list-input-title">媒体</label>
          <div class="list-input-content">
            <app-versatile-combo-box [listSource]="model.mediumTypeList" valueField="mediumType" labelField="mediumName"
              [(ngModel)]="model.mediumType" [required]="true" [width]="200" [tabindex]="0" [visible]="true" [autofocus]="false" [dspBothField]="true"
              (ngModelChange)="mediumTypeChangedHandler()" forcedEnabledMode="true" id="cmb_MediumType" [subid]="'cmb_MediumType'" #cmb_MediumType>
            </app-versatile-combo-box>
          </div>
        </div>
        <div class="column-list">
          <label class="list-input-title">企画回</label>
          <div class="list-input-content">
            <input type="text" class="deliv-catalog text-label-required" #txti_CatalogId [(ngModel)]="model.catalogId" [maxlength]="8" plessInputTextSub [restrict]="'[0-9]'"
              (ngModelChange)="catalogIdChangedHandler();">
          </div>
        </div>
      </div>
      <button class="btn-secondary" #btn_Display (click)="displayButtonClickHandler()" 
        forcedEnabledMode="true" [tabindex]="0">表示</button>
    </div>
  </div>

  <div>
    <h1>依頼一覧</h1>
    <wj-flex-grid #dtg_RequestInfoList [style.width.px]="1623" [style.height.px]="696" [itemsSource]="model.requestInfoList"
      [allowDragging]="'None'" horizontalScrollPolicy="'off'" [headersVisibility]="'Column'" [selectionMode]="'Row'"
      verticalScrollPolicy="'on'" [allowSorting]="false" [autoRowHeights]="true" forcedEnabledMode="true" [tabindex]="0">
      <wj-flex-grid-column [header]="'依頼ステータス'" [minWidth]="5" [width]="100" [binding]="'requestStatusName'" [isReadOnly]="true"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'依頼種別'" [minWidth]="5" [width]="100" [binding]="'requestTypeName' "[isReadOnly]="true"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'特集'" [minWidth]="5" [width]="200" [binding]="'featureDisplay'" [isReadOnly]="true"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'部門'" [minWidth]="5" [width]="120" [binding]="'classDisplay'" [isReadOnly]="true"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'中分類'" [minWidth]="5" [width]="120" [binding]="'middleClassDispaly'" [isReadOnly]="true"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'Pコード'" [minWidth]="5" [width]="90" [binding]="'pCode'" [isReadOnly]="true"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'商品案内用商品名'" [minWidth]="5" [width]="250" [binding]="'guideGoodsName'" [isReadOnly]="true"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'商品案内用規格名'" [minWidth]="5" [width]="200" [binding]="'guideStandardName'" [isReadOnly]="true"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'タグ情報'" [minWidth]="5" [width]="200" [binding]="'tagName'" [isReadOnly]="true"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'今回供給価格'" [minWidth]="5" [width]="100" [binding]="'thisTimeSupplyPrice'" [isReadOnly]="true" [align]="'right'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div>{{cell.item.thisTimeSupplyPrice | comma}}</div>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'価格パターン'" [minWidth]="5" [width]="90" [binding]="'pricePatternName'" [isReadOnly]="true"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'計画数'" [minWidth]="5" [width]="100" [binding]="'planNum'" [isReadOnly]="true" [align]="'right'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div>{{cell.item.planNum | comma}}</div>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'計画供給高（千円）'" [minWidth]="5" [width]="140" [binding]="'dispPlanSupplyBudget'" [isReadOnly]="true" [align]="'right'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div>{{cell.item.dispPlanSupplyBudget}}</div>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'仕入価'" [minWidth]="5" [width]="70" [binding]="'thisTimeCostPrice'" [isReadOnly]="true" [align]="'right'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div>{{cell.item.thisTimeCostPrice | comma}}</div>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'GPR'" [minWidth]="5" [width]="60" [binding]="'gpr'" [isReadOnly]="true"  [align]="'right'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div>{{cell.item.gpr | number:'1.1-1' | comma | suffix:'%'}}</div>
        </ng-template>
      </wj-flex-grid-column>
    </wj-flex-grid>
  </div>
</div>
